export function getOwaUnitCode(serial) {
    const match = serial?.match(/^.{8}(..)(..)11$/);
    if (match == null) {
        return null;
    }
    const hex = match[2];
    if (!isMicrolineAdapter(serial)) {
        return parseInt(hex, 16);
    }
    return 0x50; //this is MICROLINE pressure sensor, convert to bar later
}
export function getOwaMultiplier(unit_code) {
    switch (unit_code & 0x03) {
        case 0:
            return 0.1;
        case 1:
            return 1;
        case 2:
            return 10;
        case 3:
            return 100;
        default:
            return 1;
    }
}
export function isMicrolineAdapter(serial) {
    const match = serial?.match(/^.{8}(..)(..)11$/);
    if (match == null) {
        return false;
    }
    return match[1] !== '53';
}
